import { Pipe, PipeTransform } from '@angular/core';
import { DprCard } from '@dpr/models';

@Pipe({ name: 'backdropClass' })
export class BackdropClassPipe implements PipeTransform {
  transform(data: DprCard): string {
    if (!data || data?.dprDetailLockedDate) {
      return 'backdropLocked';
    }

    return data.dprDetailsFirstWarning == null
      ? 'backdropComplete'
      : 'backdropInProgress';
  }
}
